package co.maytes.standupbot.dashboard.features.teams

import co.maytes.standupbot.dashboard.components.motion.ViewPhase

fun TeamsListPhase.viewPhase(isEmpty: Boolean): ViewPhase = when (this) {
    TeamsListPhase.Idle, TeamsListPhase.Loading -> ViewPhase.Loading
    TeamsListPhase.Failed -> ViewPhase.Error
    TeamsListPhase.Ready -> if (isEmpty) ViewPhase.Empty else ViewPhase.Ready
}
